import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import type { CurrentCommunity } from "@/react/types/CurrentCommunity";

import { CommunityImage } from "../../OnboardingComponents/CommunityImage";

interface OtpTitleProps {
  currentCommunity: CurrentCommunity;
  subtitle?: string;
  title?: string;
}

export const OtpTitle = ({
  currentCommunity,
  title,
  subtitle,
}: OtpTitleProps) => (
  <div className="flex flex-col space-y-1.5 p-6 pb-8 pt-0 text-center">
    <div className="mb-2 flex justify-center">
      <CommunityImage
        community={currentCommunity}
        withCircleBranding={!currentCommunity}
        displayCommunityName={false}
      />
    </div>
    <div
      className="mb-1 font-semibold tracking-tight"
      style={{ letterSpacing: "0.01em" }}
    >
      <Typography.TitleLg>
        {title ?? t("otp_challenge_modal.new.title")}
      </Typography.TitleLg>
    </div>
    <Typography.BodyMd color="text-tertiary">
      {subtitle ?? t("otp_challenge_modal.new.subtitle")}
    </Typography.BodyMd>
  </div>
);
